import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { IoPlayCircleSharp } from "react-icons/io5";
import { AiOutlinePlus } from "react-icons/ai";
import { RiThumbUpFill, RiThumbDownFill } from "react-icons/ri";
import { BiChevronDown } from "react-icons/bi";
import { BsCheck } from "react-icons/bs";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from "../utils/firebase-config";
import { useDispatch } from "react-redux";
import { addToLikedMovies, removeFromLikedMovies } from "../store";
import video from "../assets/tekken-8-state-of-play-sep-2022-announcement-trailer-ps5-games-ytsave.pk.mp4";
import { toast } from "react-toastify";

export default React.memo(function SearchCard({ index, movieData, isLiked = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const [email, setEmail] = useState(undefined);

  onAuthStateChanged(firebaseAuth, (currentUser) => {
    if (currentUser) {
      setEmail(currentUser.email);
    } else navigate("/login");
  });

  const addToList = async () => {
    try {
      dispatch(addToLikedMovies({ email, data: movieData }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    movieData.backdrop_path && (
      <Container
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={`https://image.tmdb.org/t/p/w500${movieData.backdrop_path}`}
          alt="card"
          onClick={() => navigate("/player")}
        />

        {isHovered && (
          <div className="hover">
            <div className="image-video-container">
              <img
                src={`https://image.tmdb.org/t/p/w500${movieData.backdrop_path}`}
                alt="card"
                onClick={() => navigate("/player")}
              />
              <video
                src={video}
                autoPlay={true}
                loop
                muted
                onClick={() => navigate("/player")}
              />
            </div>
            <div className="info-container flex column">
              <h3 className="name" onClick={() => navigate("/player")}>
                {movieData.title}
              </h3>
              <div className="icons flex j-between">
                <div className="controls flex">
                  <IoPlayCircleSharp
                    title="Play"
                    onClick={() => navigate("/player")}
                  />
                  <RiThumbUpFill title="Like" />
                  <RiThumbDownFill title="Dislike" />
                  {isLiked ? (
                    <BsCheck
                      title="Remove from List"
                      onClick={() => {
                        dispatch(
                          removeFromLikedMovies({ movieId: movieData.id, email })
                        );
                        toast.success("Movie removed from list!", {
                          position: toast.POSITION.TOP_RIGHT,
                          autoClose: 300
                        });
                      }}
                    />
                  ) : (
                    <AiOutlinePlus
                      title="Add to my list"
                      onClick={() => {
                        addToList();
                        toast.success("Movie added to list!", {
                          position: toast.POSITION.TOP_RIGHT,
                          autoClose: 500
                        });
                      }}
                    />
                  )}
                </div>
                <div className="info">
                  <BiChevronDown title="More Info" />
                </div>
              </div>
              <div className="genres flex">
                <ul className="flex">
                  {movieData.genres &&
                    movieData.genres.map((genre, index) => (
                      <li key={index}>{genre}</li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </Container>
    )
  );
});


const Container = styled.div`
  max-width: 230px;
  width: 230px;
  height: 100%;
  cursor: pointer;
  position: relative;
  img {
    border-radius: 0.2rem;
    width: 100%;
    height: auto;
    max-height: 320px;
    object-fit: contain; /* Adjust the object-fit property */
    z-index: 10;
  }
  .hover {
    z-index: 99;
    height: max-content;
    width: 20rem;
    position: absolute;
    top: -18vh;
    left: 0;
    border-radius: 0.3rem;
    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
    background-color: #181818;
    transition: 0.4s ease-in-out;
    .image-video-container {
      position: relative;
      height: 140px;
      img {
        width: 100%;
        height: 140px;
        object-fit: cover;
        border-radius: 0.3rem;
        top: 0;
        z-index: 4;
        position: absolute;
      }
      video {
        width: 100%;
        height: 140px;
        object-fit: cover;
        border-radius: 0.3rem;
        top: 0;
        z-index: 5;
        position: absolute;
      }
    }
    .info-container {
      padding: 1rem;
      gap: 0.5rem;
    }
    .icons {
      .controls {
        display: flex;
        gap: 1rem;
      }
      svg {
        font-size: 2rem;
        cursor: pointer;
        transition: 0.3s ease-in-out;
        &:hover {
          color: #b8b8b8;
        }
      }
    }
    .genres {
      ul {
        gap: 1rem;
        li {
          padding-right: 0.7rem;
          &:first-of-type {
            list-style-type: none;
          }
        }
      }
    }
  }
`;
